<template>
  <a class="label__link mod--delete w-inline-block">
    <v-icon v-if="loading">
      mdi-spin mdi-sync
    </v-icon>

    <v-icon v-else color="#000">
      mdi-eye-outline
    </v-icon>
  </a>
</template>

<script>
export default {
  name: 'LKIconEye',
  props: {
    loading: Boolean,
  },
}
</script>
